<div class="entity-table-component">
  <table class="table table-hover table-striped">
    <thead>
      <tr>
        <th *ngIf="allowMultiSelect" class="py-2">
          <input
            class="form-check-input mt-0 me-3"
            type="checkbox"
            (change)="toggleAllTestEventsSelected()"
            [checked]="areAllTestEventsSelected()"
            [indeterminate]="selectedEvents.length > 0 && !areAllTestEventsSelected()"
            [attr.aria-label]="'message.test.event-table.aria-labels.toggle-all-selected' | translate"
          />
        </th>
        <th (click)="sortBy('testEventId')" class="py-2">
          {{ 'table.change-booking.header.id' | translate }}
          <i 
            class="bi" 
            [class]="sortColumn === 'testEventId' ? (sortDirection === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill') : 'bi-funnel-fill text-muted'">
          </i>
        </th>
        <th (click)="sortBy('testareaName')" class="py-2">
          {{ 'table.change-booking.header.test-location' | translate }}
          <i 
            class="bi" 
            [class]="sortColumn === 'testareaName' ? (sortDirection === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill') : 'bi-funnel-fill text-muted'">
          </i>
        </th>
        <th (click)="sortBy('eventdate')" class="py-2">
          {{ 'table.change-booking.header.event-date' | translate }}
          <i 
            class="bi" 
            [class]="sortColumn === 'eventdate' ? (sortDirection === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill') : 'bi-funnel-fill text-muted'">
          </i>
        </th>
        <th (click)="sortBy('eventtime')" class="py-2">
          {{ 'table.change-booking.header.event-time' | translate }}
          <i 
            class="bi" 
            [class]="sortColumn === 'eventtime' ? (sortDirection === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill') : 'bi-funnel-fill text-muted'">
          </i>
        </th>
        <th (click)="sortBy('testCenterName')" class="py-2">
          {{ 'table.change-booking.header.test-center' | translate }}
          <i 
            class="bi" 
            [class]="sortColumn === 'testCenterName' ? (sortDirection === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill') : 'bi-funnel-fill text-muted'">
          </i>
        </th>
        <th (click)="sortBy('maximumCapacity')" class="py-2">
          {{ 'table.change-booking.header.max-capacity' | translate }}
          <i 
            class="bi" 
            [class]="sortColumn === 'maximumCapacity' ? (sortDirection === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill') : 'bi-funnel-fill text-muted'">
          </i>
        </th>
        <th (click)="sortBy('numberOfBookings')" class="py-2">
          {{ 'table.change-booking.header.booked-already' | translate }}
          <i 
            class="bi" 
            [class]="sortColumn === 'numberOfBookings' ? (sortDirection === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill') : 'bi-funnel-fill text-muted'">
          </i>
        </th>
        <th (click)="sortBy('utilizationRatio')" class="py-2">
          {{ 'table.change-booking.header.utilization' | translate }}
          <i 
            class="bi" 
            [class]="sortColumn === 'utilizationRatio' ? (sortDirection === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill') : 'bi-funnel-fill text-muted'">
          </i>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let row of sortedEvents"
        (click)="newEventChosen(row)"
        [class.active-row]="row.testEventId === activeRowId"
        [class.bookedEvent]="row.testEventId === currentTestEventId"
      >
        <td *ngIf="allowMultiSelect" (click)="$event.stopPropagation()">
          <input
            class="form-check-input mt-0 me-3"
            type="checkbox"
            (change)="toggleRowSelection(row)"
            [checked]="isSelected(row)"
            [attr.aria-label]="'message.test.event-table.aria-labels.toggle-single-selected' | translate"
          />
        </td>
        <td>{{ row.testEventId }}</td>
        <td>{{ row.testareaName }}</td>
        <td>{{ row.testEventTime | localizedDate: 'mediumDate' }}</td>
        <td>{{ row.testEventTime | localizedDate: 'shortTime' }}</td>
        <td>{{ row.testCenterName }}</td>
        <td>{{ row.maximumCapacity }}</td>
        <td>{{ row.numberOfBookings }}</td>
        <td>{{ row.utilizationRatio | percent:undefined:currentLanguage }}</td>
      </tr>
    </tbody>
  </table>
</div>
